import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_postmail",
  "use": "icon_postmail-usage",
  "viewBox": "0 0 30 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 24\" id=\"icon_postmail\"><path d=\"M12.482 9l5.509 3L23.5 9M5.138 13.5h2.448M2.69 10.5h4.896\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M7.586 7.5V7c0-1.105 1.096-2 2.448-2h15.914c1.352 0 2.448.895 2.448 2v10c0 1.105-1.096 2-2.448 2H10.034c-1.352 0-2.448-.895-2.448-2v-.5\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol